
import React, { useEffect, useRef, useState } from "react";
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { Player } from '@lottiefiles/react-lottie-player';

import animationMobile from '../data/images/animation-mobile-logout-banner.json';
// import chestOpened from '../data/banner/chest-opened.png';
// import bonanza from '../data/banner/bonanza.png';
// import bigbass from '../data/banner/bigbass.png';
// import olympus from '../data/banner/olympus.png';
// import doghouse from '../data/banner/doghouse.png';
// import wolfgold from '../data/banner/wolfgold.png';
// import discount from '../data/banner/discount.png';

export default function HomeBannerLogout() {
	const locale = useSelector((state) => state.globalContent.data.locale);
	const [step, setStep] = useState(isMobile ? 0 : 1);
	const playerRef = useRef(null);

	useEffect(() => {
		if (step === 1) {
			setTimeout(() => {
				setStep(2)
			}, 600)
		}
	})

	return (
		<section className="section-margin home-banner-logout-section">
			<Container fluid="lg">
				<div className={`home-banner-logout-container mt-2 animate__animated animate__faster animate__fadeIn`}>
					{/* <img src="https://cherryspins.b-cdn.net/hero-banner-logout/discount.png" className="image-discount" /> */}

					{/* <div className={`grey-gradient ${!colorChange && 'gradient-opacity-1'}`}></div> */}
					<div className={`red-gradient gradient-opacity-1`}></div>

					<div className="home-banner-logout-content-wrapper">
						<div className="home-banner-logout-text pt-3">

							{/* Heading */}
							<span className='title white-100 animate__animated animate__faster animate__fadeIn'>Bonus up to</span>
							<h1 className='title-xl white-100 animate__animated animate__faster animate__fadeIn'><span className="personalized-gold">600%</span> and <span className="personalized-gold">1800</span> free spins!</h1>

							{/* Subheading */}
							<p className="subtitle-xl white-100 animate__animated animate__faster animate__fadeIn">+ <span className="personalized-gold">10 free spins</span> with no deposit!</p>

							{/* Buttons */}
							<div className="home-banner-logout-buttons">
								<Link to={`/${locale}?register`} className="btn btn-main-lg">Claim now</Link>
								{/* <a className="btn-secondary ms-3" href="#welcome-package-terms">Learn more</a> */}
							</div>

						</div>
						<div className="home-banner-logout-logos">
							<img className="home-banner-logout-award" src='https://cherryspins.b-cdn.net/images/award.png' />
							<img className="home-banner-logout-psp" src='https://cherryspins.b-cdn.net/images/supported-payments-1.png' />
						</div>
					</div>
					<div className="home-banner-logout-image-wrapper">
						<div className="home-banner-logout-image-scale">

							{
								step === 0 && (
									// <img src="https://cherryspins.b-cdn.net/hero-banner-logout/full-image-mobile-1.png"
									// 	className="image-chest-opened animate__animated animate__faster animate__fadeIn" />
									<Player
										ref={playerRef}
										onEvent={event => {
											if (event === 'load') {
												setTimeout(() => { playerRef.current.pause() }, 1000);
											}
										}}
										className="image-chest-opened-mobile-animated"
										autoplay
										src={animationMobile}
										//style={{ height: '245px', width: '430px' }}
									/>
								)
							}

							{
								step > 0 && (
									<>
										<img src="https://cherryspins.b-cdn.net/hero-banner-logout/chest-closed.png"
											className={`image-chest-closed image-chest-closed animate__animated animate__faster ${step === 1 ? 'animate__fadeInRight' : 'image-hidden'}`} />

										<img src="https://cherryspins.b-cdn.net/hero-banner-logout/chest-opened.png"
											className={`image-chest-opened animate__animated animate__faster_custom ${step < 2 && 'image-hidden'} ${step === 2 && 'animate__pulse_custom'}`} />

										<img src="https://cherryspins.b-cdn.net/hero-banner-logout/bigbass.png" className={`image-bigbass animate__animated animate__faster ${step < 2 && 'image-hidden'} ${step === 2 && 'animate__bounceIn'}`} />
										<img src="https://cherryspins.b-cdn.net/hero-banner-logout/doghouse.png" className={`image-doghouse animate__animated animate__faster ${step < 2 && 'image-hidden'} ${step === 2 && 'animate__bounceIn'}`} />
										<img src="https://cherryspins.b-cdn.net/hero-banner-logout/olympus.png" className={`image-olympus animate__animated ${step < 2 && 'image-hidden'} ${step === 2 && 'animate__bounceIn'}`} />
										<img src="https://cherryspins.b-cdn.net/hero-banner-logout/wolfgold.png" className={`image-wolfgold animate__animated ${step < 2 && 'image-hidden'} ${step === 2 && 'animate__bounceIn'}`} />
										<img src="https://cherryspins.b-cdn.net/hero-banner-logout/bonanza.png" className={`image-bonanza animate__animated ${step < 2 && 'image-hidden'} ${step === 2 && 'animate__bounceIn'}`} />
									</>
								)
							}
						</div>
					</div>
				</div>
			</Container>
		</section >
	);
}